import Signin from "pages/signin"
import PageNotFound from "pages/404"
import { ErrorBoundary } from "components"
import { PublicContainer } from "containers"

const publicRoutes = {
  errorElement: <ErrorBoundary />,
  element: <PublicContainer />,
  children: [
    {
      path: "/",
      element: <Signin />
    },
    {
      path: "*",
      element: <PageNotFound />
    }
  ]
}

export default publicRoutes